<script setup>
import { computed } from 'vue'
import { useUserStore } from '../../stores/user'
import { useLoadingFeedback } from '../../util/useLoadingFeedback'
import CircleButton from '../elements/CircleButton.vue'
import SpinIcon from '../../assets/icons/spin.svg'
import HeartIcon from '../../assets/icons/heart.svg'
import ErrorIcon from '../../assets/icons/error.svg'

const props = defineProps({
  track: {
    type: Object,
    required: true,
  },
})

const user = useUserStore()
const liked = computed(() => user.ratings.hasLiked(props.track))

const { loading, error, execute: toggleLike } = useLoadingFeedback(() => user.ratings.toggleLike(props.track))

const buttonLabel = computed(() =>
  liked.value
    ? `Unlike track ${props.track.title} van ${props.track.artist?.name}`
    : `Like track ${props.track.title} van ${props.track.artist?.name}`
)
</script>

<template>
  <CircleButton
    class="group/like hover:bg-primary joe:group/like hover:bg-opacity-100 text-primary hover:text-white focus:ring-primary focus:ring-2 focus:ring-offset-4"
    :title="buttonLabel"
    :aria-label="buttonLabel"
    :aria-pressed="liked"
    @click="toggleLike"
  >
    <SpinIcon v-if="loading" class="w-5 h-5" aria-hidden="true" />
    <ErrorIcon v-else-if="error" class="w-5 h-5" aria-hidden="true" />
    <HeartIcon
      v-else
      class="w-5 h-5 transition-all duration-300"
      :class="
        liked
          ? 'stroke-none'
          : 'stroke-primary joe:stroke-secondary willy:stroke-primary-alt group-hover/like:stroke-white fill-none'
      "
      aria-hidden="true"
    />
  </CircleButton>
</template>
